import * as React from 'react';
import styled from 'styled-components';
import {lighten} from 'polished';
import {transition} from 'helpers/css';
import outline from 'helpers/outline';

export interface ControlButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  // todo: Когда появлятся уведомления, доработать кнопку
}

const Container = styled.button`
  justify-content: center;
  align-items: center;
  display: grid;
  padding: 0;
  margin: auto;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  ${transition()};
  background-color: ${({theme}) => `
    ${theme.variables.backgroundColor};
  `};
  
  &:hover,
  &:focus-visible {
    background-color: ${({theme}) => `
      ${lighten(.08, theme.variables.backgroundColor)};
    `};
  }

  &:active {
    background-color: ${({theme}) => `
      ${lighten(.14, theme.variables.backgroundColor)};
    `};
  }
  
  &:focus-visible {
    ${outline(4, 1)};
  }
`;

/**
 * This component renders a button inside the sidebar.
 * @param {ControlButtonProps} props
 * @return {React.ReactElement<ControlButtonProps>}
 * @constructor
 */
export default function ControlButton(
    props: ControlButtonProps,
): React.ReactElement<ControlButtonProps> {
  return (
    <Container {...props} />
  );
}
